import React, { Suspense } from 'react'
import { Switch, Route, NotFound, AuthRoute } from '@fs/zion-router'
import type { RouteComponentProps } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import PageSkeleton from './components/PageSkeleton/PageSkeleton'
import usePlaceSystemHealthStatusOverlay from './components/hooks/usePlaceSystemStatusOverlay'
import EnglandMapsPage from './EnglandMapsPage/EnglandMapsPage'
import { SEARCH_PATH, SUGGEST_PATH } from './components/MapsLayout/routePaths'

const PlacesApp = React.lazy(() => import('./components/PlacesApp/PlacesApp'))

function App(): JSX.Element {
  usePlaceSystemHealthStatusOverlay()
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageSkeleton />}>
        <Switch>
          {/* Array path keeps one Route matched across all three paths so PlacesApp/map never remount;
              /suggest is auth-gated inside MapsLayout (a separate AuthRoute would remount the map) (STD-18118) */}
          <Route
            exact
            path={['/', SEARCH_PATH, SUGGEST_PATH]}
            render={(props: RouteComponentProps) => <PlacesApp {...props} />}
          />
          <AuthRoute exact path="/mapp" component={EnglandMapsPage} />
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  )
}
export default App
